/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon32Regular = forwardRef('ArrowDim2DiagMinRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "m20.414 13 8.293-8.293a1 1 0 0 0-1.414-1.414L19 11.586V5a1 1 0 1 0-2 0v7a3 3 0 0 0 3 3h7a1 1 0 1 0 0-2h-6.586Z" }),
        React.createElement("path", { d: "M13 27v-6.586l-8.293 8.293a1 1 0 0 1-1.414-1.414L11.586 19H5a1 1 0 1 1 0-2h7a3 3 0 0 1 3 3v7a1 1 0 1 1-2 0Z" })));
});
